// Labels come from src/data/i18n.js (nav.<key>).
// Paths may be functions of the current language.
const routes = [
  {
    index: true,
    key: 'home',
    label: 'Sara Buczna',
    path: '/',
  },
  {
    key: 'about',
    path: '/about',
  },
  {
    key: 'recruiters',
    path: '/recruiters',
  },
  {
    key: 'resume',
    path: (lang) => `/resume/${lang}`,
  },
];

export default routes;
